import React, { CSSProperties, ReactNode } from "react";
import classes from "./ModalBody.module.scss";

interface IProps {
  children: ReactNode;
  style?: CSSProperties;
}

const ModalBody: React.FC<IProps> = ({ children, style }) => {
  return (
    <div className={classes.Container} style={style}>
      {children}
    </div>
  );
};

export default ModalBody;
